<div class="p-8">
  <!-- Header -->
  <div class="flex items-start justify-between mb-8">
    <div>
      <h1 class="text-sm font-bold text-navy-600">Rollup Taxonomies</h1>
      <p class="text-xs text-slate-500 mt-1">
        Consolidate categories from multiple taxonomies for global reporting and strategic analysis.
      </p>
    </div>
    <button
      type="button"
      (click)="showCreate.set(true)"
      class="flex items-center gap-2 bg-accent-500 hover:opacity-90 text-white text-xs font-semibold px-4 py-2.5 rounded-xl transition-opacity cursor-pointer shrink-0"
    >
      <img src="/icons/plus-white-icon.svg" class="w-4 h-4" alt="" />
      Create Rollup Taxonomy
    </button>
  </div>

  <!-- Search -->
  <div class="flex items-center gap-3 mb-6">
    <div class="relative flex-1 max-w-xs">
      <img
        src="/icons/search-icon.svg"
        class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none"
        alt=""
      />
      <input
        type="text"
        placeholder="Filter by Name"
        [value]="searchQuery()"
        (input)="onSearchInput($event)"
        class="w-full pl-9 pr-4"
      />
    </div>
  </div>

  <!-- Table -->
  <div class="bg-white rounded-2xl border border-slate-100 shadow-card overflow-hidden">
    <app-data-table
      [columns]="columns()"
      [rows]="rollupTaxonomies()"
      [total]="total()"
      [page]="pageIndex() + 1"
      [pageSize]="pageSize"
      [loading]="loading()"
      [clickableRows]="true"
      (pageChange)="onPageChange($event)"
      (rowAction)="onRowAction($event)"
    />
  </div>
</div>

@if (showCreate()) {
  <app-create-rollup-taxonomy-modal (closed)="showCreate.set(false)" />
}

<!-- Cell Templates -->
<ng-template #nameTpl let-row>
  <div class="flex items-center gap-2.5">
    <img src="/icons/rollup-taxonomies-icon.svg" alt="" class="w-4 h-4 shrink-0" />
    <span class="font-medium text-navy-900">{{ row.name }}</span>
  </div>
</ng-template>

<ng-template #categoryTpl let-row>
  <span
    class="inline-block px-2.5 py-0.5 rounded text-2xs font-semibold uppercase tracking-wide border"
    [ngClass]="{
      'border-accent-500 text-accent-500': row.classificationType === ClassificationType.Situation,
      'border-purple-500 text-purple-500': row.classificationType === ClassificationType.Response,
    }"
  >
    {{ row.classificationType === ClassificationType.Situation ? 'Situation' : 'Response' }}
  </span>
</ng-template>
